import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function OldSolutionsFail() {
  const failures = [{
    bad: 'Just post consistently.',
    reality: '(Consistently what?)'
  }, {
    bad: 'Grow your audience.',
    reality: '(Slow, and not required for UGC.)'
  }, {
    bad: 'Be confident.',
    reality: '(Confidence comes after reps, not before.)'
  }, {
    bad: 'Make it perfect.',
    reality: '(Perfection is procrastination dressed like standards.)'
  }];
  return <section className="w-full bg-[#FAFAF5] text-[#0F1B2D] py-24 px-6 md:px-12" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-151">
            Why what you've tried hasn't worked
          </h2>
          <p className="text-xl text-gray-600" data-id="element-152">
            Because it's built around hope.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-153">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 text-lg md:text-xl p-4 bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-154">
              <div className="flex items-center gap-3 text-red-400 line-through decoration-red-400 decoration-2" data-id="element-155">
                <XCircle className="w-6 h-6 flex-shrink-0" data-id="element-156" />
                <span className="font-medium" data-id="element-157">"{item.bad}"</span>
              </div>
              <span className="hidden md:block text-gray-300" data-id="element-158">→</span>
              <span className="text-[#0F1B2D] font-semibold" data-id="element-159">
                {item.reality}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center mt-12" data-id="element-160">
          <p className="text-2xl md:text-3xl font-bold text-[#E8722A]" data-id="element-161">
            This kit replaces hope with structure.
          </p>
        </motion.div>
      </div>
    </section>;
}